import { render, staticRenderFns } from "./SyllabusesList.vue?vue&type=template&id=a680e618&scoped=true"
import script from "./SyllabusesList.vue?vue&type=script&lang=js"
export * from "./SyllabusesList.vue?vue&type=script&lang=js"
import style0 from "./SyllabusesList.vue?vue&type=style&index=0&id=a680e618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a680e618",
  null
  
)

export default component.exports